import {
  PageCollection,
  HttpExclude,
  Request,
  Resource,
  ResourceCollection,
} from 'simpli-web-sdk'
import {TipoVeiculo} from '@/model/resource/TipoVeiculo'
import {NoneResource} from '@/model/NoneResource'

@HttpExclude()
export class TipoVeiculoCollection extends PageCollection<TipoVeiculo> {
  constructor() {
    super(TipoVeiculo)
  }

  queryAsPage() {
    return this.listTipoVeiculo()
  }

  async listTipoVeiculo() {
    return await Request.get(`/admin/tipo-veiculo`, {
      params: this.params,
    })
      .name('listTipoVeiculo')
      .as(this)
      .getResponse()
  }
  async listTipoVeiculoAtivo() {
    return await Request.get(`/admin/tipo-veiculo/ativo`, {
      params: this.params,
    })
      .name('listTipoVeiculoAtivo')
      .as(this)
      .getResponse()
  }
  async listCsvTipoVeiculo() {
    return await Request.get(`/admin/tipo-veiculo/csv`, {
      params: this.params,
    })
      .as(this)
      .getResponse()
  }

  async updateTipoVeiculoById(id: number) {
    return await Request.patch(`/admin/tipo-veiculo/${id}`, {
      params: this.params,
    })
      .as(this)
      .getResponse()
  }

  async deleteTipoVeiculoById(id: number) {
    return await Request.delete(`/admin/tipo-veiculo/${id}`, {
      params: this.params,
    })
      .as(this)
      .getResponse()
  }

  async createTipoVeiculo() {
    return await Request.post(`/admin/tipo-veiculo`, {
      params: this.params,
    })
      .as(this)
      .getResponse()
  }

  async updateTipoVeiculo() {
    return await Request.post(`/admin/tipo-veiculo/persist`, {
      params: this.params,
    })
      .as(this)
      .getResponse()
  }

  async tipoVeiculocCsvgenerator() {
    return await Request.get(`/admin/tipo-veiculo/csv`, {
      params: this.params,
    })
      .as(this)
      .getResponse()
  }

  async getTipoVeiculoById(id: number) {
    return await Request.get(`/admin/tipo-veiculo/${id}`, {
      params: this.params,
    })
      .as(this)
      .getResponse()
  }
  async options() {
    const {data} = await this.listTipoVeiculoAtivo()
    const {items} = data
    return new ResourceCollection(
      NoneResource,
      items.map(
        ({idTipoVeiculo: $id, nome: $tag}) =>
          ({
            $id,
            $tag,
          } as Resource)
      )
    )
  }
}
